module.exports = __webpack_public_path__ + "static/media/j_of_clubs2.2f25fde4.png";